export default __webpack_public_path__ + "static/media/bg18.420c9a16.jpg";